import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["subject", "content", "variables", "loading", "previewTab", "previewPane"]
  static values = {
    paramKey: String,
    previewPath: String,
    previewSendPath: String,
    variables: Array
  }

  preview(event) {
    let self = this;

    event.preventDefault();
    this.$previewTabTarget.tab("show");

    // Show loading
    this.$loadingTarget.removeClass("d-none");
    this.$previewPaneTarget.html("");

    // Send request
    $
      .post(this.previewPathValue, this.payload)
      .done(function(content) {
        self.$previewPaneTarget.html(`<div class="trix-content formatted_content">${content}</div>`);
      })
      .fail(function(response) {
        self.$previewPaneTarget.html("");
        $.each(response.responseJSON, function() {
          self.$previewPaneTarget.append(`<p class="help-block"><strong>${this.type}</strong>: ${this.message}</p>`);
        })
      })
      .always(function() {
        self.$loadingTarget.addClass("d-none");
      });
  }

  send(event) {
    event.preventDefault();

    // Send request
    $
      .post(this.previewSendPathValue, this.payload)
      .done(function(content) {
        new App.FancyMessage("success", "Email is being sent out to you now.").display();
      })
      .fail(function(response) {
        new App.FancyMessage("error", "Something went wrong. Please, try again later.").display();
      });
  }

  get subject() {
    return $(this.subjectTarget).val();
  }

  get content() {
    return $(this.contentTarget).val();
  }

  get variables() {
    if (this.hasVariablesTarget) {
      return $(this.variablesTarget).val();
    } else {
      return this.variablesValue;
    }
  }

  get payload() {
    let object = {};
    object[this.paramKeyValue] = {
      subject: this.subject,
      content: this.content,
      variables: this.variables
    };

    return object;
  }

  get $loadingTarget() {
    return $(this.loadingTarget);
  }

  get $previewPaneTarget() {
    return $(this.previewPaneTarget);
  }

  get $previewTabTarget() {
    return $(this.previewTabTarget);
  }
}
